<template>
  <span>

    <!-- view notification links -->
    <b-dropdown-item v-if="nid && day" custom aria-role="menuitem" class="is-paddless">
      <div class="buttons is-centered">
        <b-tooltip label="View notification" type="is-dark">
          <b-button @click="view" :type="is_v" class="is-outlined">
              <font-awesome-icon icon="eye"/>
          </b-button>
        </b-tooltip>
        <CopyNotification :day="day" :nid="nid" :variant="variant" />
        <b-tooltip label="Open in new window" type="is-dark">
          <b-button @click="open" :type="is_v" class="is-outlined">
            <font-awesome-icon icon="square-arrow-up-right"/>
          </b-button>
        </b-tooltip>
      </div>
    </b-dropdown-item>
    <!-- eo:view notification links -->

    <hr class="dropdown-divider" />

    <!-- show context -->
    <b-dropdown-item @click="showContext = !showContext" has-link aria-role="menuitem">
      <a href="#">
        <font-awesome-icon icon="circle-info" :class="`${ht_v} mr-2`"/>
        Context
      </a>
    </b-dropdown-item>
    <!-- eo:show context -->

    <!-- show context -->
    <b-dropdown-item custom has-link aria-role="menuitem">
      <router-link :to="{ name: 'subject', params: {id: n.deviceId }}">
        Device Mapping
      </router-link>
    </b-dropdown-item>
    <!-- eo:show context -->

    <!-- context modal -->
    <portal v-if="showContext" to="outer">
      <NotificationContext v-model="showContext" :n="n" />
    </portal>
    <!-- eo:context modal -->

    <hr class="dropdown-divider" />

    <!-- filter by device -->
    <b-dropdown-item @click="filterByDeviceId" has-link aria-role="menuitem">
      <a href="#">
        Only <strong v-text="n.deviceId"/>
      </a>
    </b-dropdown-item>
    <!-- eo:filter by device -->

    <!-- filter by package name -->
    <b-dropdown-item v-if="meta['package-name']" @click="filterByPackageName" has-link aria-role="menuitem">
      <a href="#">
        Only app <strong>{{ meta['package-name'] }}</strong>
      </a>
    </b-dropdown-item>
    <!-- eo:filter by package name -->

    <!-- filter by mobile event type -->
    <b-dropdown-item v-if="meta['eventType']" @click="filterByMobileEventType" has-link aria-role="menuitem">
      <a href="#">
        Only <strong>{{ meta['eventType'] }}</strong> events
      </a>
    </b-dropdown-item>
    <!-- eo:filter by package name -->

    <!-- filter by message -->
    <b-dropdown-item v-if="!is_mobile" @click="filterByMessage" has-link aria-role="menuitem">
      <a href="#">
        Only these events
      </a>
    </b-dropdown-item>
    <!-- eo:filter by message -->

    <!-- from this event -->
    <b-dropdown-item @click="fromThisEvent(0, 5, 'oldestFirst')" has-link aria-role="menuitem">
      <a href="#">
        <font-awesome-icon icon="clock" class="has-text-info mr-2"/>
        5mins <strong>after</strong> this event
      </a>
    </b-dropdown-item>
    <b-dropdown-item @click="fromThisEvent(5, 0, 'mostRecent')" has-link aria-role="menuitem">
      <a href="#">
        <font-awesome-icon icon="clock" class="has-text-info mr-2"/>
        5mins <strong>leading up</strong> to this event
      </a>
    </b-dropdown-item>
    <!-- eo:from this event -->

  </span>
</template>

<script>
import NotificationContext from '../NotificationContext.vue'
import { mobileMessages } from '@/services/consts'
import * as moment from 'moment'
export default {
  components: { NotificationContext },
  props: { 
    n: Object,
    variant: String,
  },
  data () {
    return {
      showContext: false
    }
  },
  computed: {
    meta () { return this.n.metaData },
    v () { return this.variant || 'dark' },
    is_v () { return `is-${this.v}` },
    ht_v () { return `has-text-${this.v}` },
    nid () { return this.n.metaData._id },
    day () {
      const indexSplit = this.meta._index.split('-')
      // only want to keep the last 3 parts (year, month, day)
      for (let i=0; i<indexSplit.length-2; i++) {
        indexSplit.shift()
      }
      return indexSplit.join('-')
    },
    n_link () { 
      const { nid, day } = this
      return { name: 'notification', params: { day, nid } }
    },
    is_mobile () {
      return mobileMessages.includes(this.n.message)
    }
  },
  methods: {
    returnToSearchIfNeccessary () {
      if (this.$route.name !== 'search') {
        this.$router.push({ name: 'search' })
      }
    },
    view () {
      this.$router.push(this.n_link)
    },
    open () {
      window.open(this.$router.resolve(this.n_link).href, this.nid)
    },
    filterByDeviceId () {
      this.$store.commit('filters/setDevices', [this.n.deviceId])
      this.returnToSearchIfNeccessary()
    },
    filterByPackageName () {
      this.$store.commit('filters/setDeviceType', 'mobile')
      this.$store.commit('filters/setMobilePackageName', this.meta['package-name'])
      this.returnToSearchIfNeccessary()
    },
    filterByMobileEventType () {
      this.$store.commit('filters/setDeviceType', 'mobile')
      this.$store.commit('filters/setMobileEventTypes', [this.meta.eventType])
      this.returnToSearchIfNeccessary()
    },
    filterByMessage () {
      this.$store.commit('filters/setDeviceType', 'desktop')
      this.$store.commit('filters/setMessages', [this.n.message])
      this.returnToSearchIfNeccessary()
    },
    fromThisEvent (leadInMins, leadOutMins, orderBy) {
      const triggerPoint = this.n['@timestamp']
      const start = moment(triggerPoint).subtract({ minutes: leadInMins }).toISOString()
      const end = moment(triggerPoint).add({ minutes: leadOutMins }).toISOString()
      this.$store.commit('filters/setDateScope', `period|${start}|${end}`)
      this.$store.commit('filters/setDevices', [this.n.deviceId])
      if (orderBy) {
        this.$store.commit('filters/setOrderBy', orderBy)
      }
      this.returnToSearchIfNeccessary()
    },
  }
}
</script>